var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tree-item", staticStyle: { "margin-left": "20px" } },
    [
      _c(
        "div",
        { staticStyle: { "background-color": "white", padding: "5px" } },
        [
          _vm.item.children && _vm.item.children.length
            ? _c(
                "button",
                {
                  on: {
                    click: () => {
                      this.showChildren = !this.showChildren
                    },
                  },
                },
                [
                  !_vm.showChildren
                    ? _c("i", { staticClass: "fa fa-caret-right" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showChildren
                    ? _c("i", { staticClass: "fa fa-caret-down" })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v("\n      " + _vm._s(_vm.item.name) + "\n"),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "action-button", on: { click: _vm.makeRoot } },
            [_c("i", { staticClass: "fa fa-tree" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "action-button",
              on: {
                click: () => {
                  this.searching = !this.searching
                },
              },
            },
            [_c("i", { staticClass: "fa fa-truck-moving" })]
          ),
          _vm._v(" "),
          _vm.item.tag_id
            ? _c(
                "button",
                { staticClass: "action-button", on: { click: _vm.deleteNode } },
                [_c("i", { staticClass: "fa fa-trash" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "action-button",
              attrs: {
                to: { name: "system.tags.node", params: { id: _vm.item.id } },
              },
            },
            [_c("i", { staticClass: "fa fa-user" })]
          ),
          _vm._v(" "),
          _vm.searching
            ? _c(
                "div",
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchString,
                        expression: "searchString",
                      },
                    ],
                    domProps: { value: _vm.searchString },
                    on: {
                      keypress: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.searchNodes.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.searchString = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.searchNodes } }, [
                    _c("i", { staticClass: "fa fa-search" }),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.searchResults, function (result) {
                    return _c("div", { key: result.id }, [
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _vm._l(result.ancestors, function (ancestor) {
                            return _c(
                              "span",
                              {
                                key: ancestor.id,
                                staticStyle: { "font-size": "12px" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(ancestor.name) +
                                    " >\n            "
                                ),
                              ]
                            )
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(result.name) +
                              "\n          "
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: () => {
                              _vm.appendToNode(result.id, false)
                            },
                          },
                        },
                        [_c("i", { staticClass: "fa fa-mail-forward" })]
                      ),
                      _vm._v(" "),
                      _vm.item.tag_id
                        ? _c(
                            "button",
                            {
                              on: {
                                click: () => {
                                  _vm.appendToNode(result.id, true)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fa fa-files-o" })]
                          )
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showChildren && _vm.item.children && _vm.item.children.length
        ? _vm._l(_vm.item.children, function (child) {
            return _c("system-tag-tree-item", {
              key: child.id,
              attrs: { item: child },
              on: {
                refreshTree: () => {
                  _vm.$emit("refreshTree")
                },
                editing: () => {
                  _vm.$emit("editing")
                },
              },
            })
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }